import { Icon, Typography } from '@scale/scaleui';
import ArrayBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ArrayBuilder';
import { RubricDimensionSchema } from '@scale/shared/pipelinev3/genai';
import { RubricDimension } from '@scale/shared/types/params/textcollection';
import type { TypeBuilderMapType } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemasType';

interface RubricDimensionsBuilderProps {
  name: string;
  hint?: string;
  existingValue?: Array<RubricDimension>;
  updateProperty: (arg: Array<RubricDimension> | undefined) => void;
  required?: boolean;
  typeBuilderMap: TypeBuilderMapType;
}

const RubricDimensionsBuilder: React.FC<RubricDimensionsBuilderProps> = ({
  name,
  hint,
  existingValue = [],
  updateProperty,
  typeBuilderMap,
}) => {
  const rubricDimensions = existingValue || [];
  return (
    <div className="flex flex-col gap-2">
      <Typography.Subtitle3>{name}</Typography.Subtitle3>
      {hint && <Typography.Paragraph3>{hint}</Typography.Paragraph3>}
      <ArrayBuilder
        typeBuilderMap={typeBuilderMap}
        elements={rubricDimensions}
        setElements={updateProperty}
        getKey={rubricDimension => JSON.stringify(rubricDimension)}
        getTitle={rubricDimension => rubricDimension.label || '<New Dimension>'}
        getSchema={_ => RubricDimensionSchema}
      />
      <Icon
        hasBackground
        icon={['fas', 'plus']}
        onClick={() =>
          updateProperty([
            ...rubricDimensions,
            {
              value: '',
              label: '',
              ratings: [],
            },
          ])
        }
        size="md"
        variant="primary"
      />
    </div>
  );
};

export default RubricDimensionsBuilder;
